import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../store/index.ts";
import { API_CASINO } from "../../api/casino";
import { BONUS_PROVIDER_NAME } from "../../store/enums";
import {
  getUrlProviderHover,
  getUrlProviderLogo,
  getUrlProviders,
  LIVE_PROVIDER_NAME
} from "../../utils/utils";
import { setBonusProvider, setIdProvidersLiveGame, setProviders } from "../../store/gamesSlice";

export default function useProviders() {
  const dispatch = useDispatch();
  const collectionId = useAppSelector((state) => state.common.collectionId);

  const getProviders = (collectionId) => {
    API_CASINO.list
      .providers(collectionId)
      .then((e) => {
        const list = e.data.list;
        let bonusProvider = null;
        let idProvidersLiveGame = [];

        // const providers = Object.entries(list).map(([id, provider]) => {
        //   if (BONUS_PROVIDER_NAME === provider.name) bonusProvider = { id, ...provider };
        //   if (LIVE_PROVIDER_NAME.includes(provider.name)) idProvidersLiveGame.push(id);

        //   if (!provider.name) return;

        //   return {
        //     id: id,
        //     name: provider.name,
        //     gameCount: provider.gameCount,
        //     image: getUrlProviders(provider.name),
        //     imageHover: getUrlProviderHover(provider.name),
        //     logo: getUrlProviderLogo(provider.name)
        //   };
        // });

        const providers = [];
        const entries = Object.entries(list);
        const length = entries.length;

        for (let i = 0; i < length; i++) {
          const [id, provider] = entries[i];
          if (!provider.name) continue;

          if (BONUS_PROVIDER_NAME === provider.name) bonusProvider = { id, ...provider };
          if (LIVE_PROVIDER_NAME.includes(provider.name)) idProvidersLiveGame.push(id);

          providers.push({
            id: id,
            name: provider.name,
            gameCount: provider.gameCount,
            image: getUrlProviders(provider.name),
            imageHover: getUrlProviderHover(provider.name),
            logo: getUrlProviderLogo(provider.name)
          });
        }

        dispatch(setProviders(providers));
        dispatch(setBonusProvider(bonusProvider));
        dispatch(setIdProvidersLiveGame(idProvidersLiveGame));
      })
      .catch(console.log);
  };

  useEffect(() => {
    if (!collectionId) return;
    getProviders(collectionId);
  }, [collectionId]);
}
